// Multi-Tenancy SaaS Types
// ============================================
// ENUMS
// ============================================
export var SubscriptionPlan;
(function (SubscriptionPlan) {
    SubscriptionPlan["FREE"] = "free";
    SubscriptionPlan["PRO"] = "pro";
})(SubscriptionPlan || (SubscriptionPlan = {}));
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["ACTIVE"] = "active";
    SubscriptionStatus["SUSPENDED"] = "suspended";
    SubscriptionStatus["DELETED"] = "deleted";
})(SubscriptionStatus || (SubscriptionStatus = {}));
export var UserRole;
(function (UserRole) {
    UserRole["OWNER"] = "owner";
    UserRole["ADMIN"] = "admin";
    UserRole["RECRUITER"] = "recruiter";
    UserRole["VIEWER"] = "viewer";
})(UserRole || (UserRole = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "active";
    UserStatus["DISABLED"] = "disabled";
})(UserStatus || (UserStatus = {}));
export var InvitationStatus;
(function (InvitationStatus) {
    InvitationStatus["PENDING"] = "pending";
    InvitationStatus["ACCEPTED"] = "accepted";
    InvitationStatus["EXPIRED"] = "expired";
    InvitationStatus["CANCELLED"] = "cancelled";
})(InvitationStatus || (InvitationStatus = {}));
